<template>
  <div>
    <Swiper
      :modules="[SwiperAutoplay, SwiperFreeMode, SwiperNavigation]"
      :loop="true"
      :centered-slides="true"
      :free-mode="true"
      :navigation="{
        nextEl: `.swiper-button-costume-next`,
        prevEl: `.swiper-button-costume-prev`
      }"
      :breakpoints="{
        424: {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: true
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
          centeredSlides: true
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 10,
          centeredSlides: true
        },
        1440: {
          slidesPerView: 6,
          spaceBetween: 10,
          centeredSlides: true
        }
      }"
      class="relative !px-16 py-6 !overflow-hidden w-full"
    >
      <template v-for="(team, index) in teams" :key="index + 'cf'">
        <SwiperSlide class="!min-w-[300px]">
          <TeamCard v-bind="team" />
        </SwiperSlide>
      </template>

      <div
        role="button"
        aria-label="Previous slide"
        class="swiper-button-costume-next top-1/3 absolute z-10 left-3 bg-black rounded-full h-16 w-16 flex items-center justify-center text-white"
      >
        <Icon name="i-heroicons-arrow-left" class="h-6 w-6 stroke-2" />
      </div>

      <div
        role="button"
        aria-label="Next slide"
        class="swiper-button-costume-prev top-1/3 z-10 absolute right-3 bg-black rounded-full h-16 w-16 flex items-center justify-center text-white"
      >
        <Icon name="i-heroicons-arrow-right" class="h-6 w-6 stroke-2" />
      </div>
    </Swiper>
  </div>
</template>

<script lang="ts" setup>
const teams = ref([
  {
    image: '/SBA-atv-Guides.jpeg',
    title: 'Professional ATV Guides',
    name: ''
  },
  {
    image: '/SBA-Licensed-Guide.jpeg',
    title: 'Licensed River Guides',
    name: ''
  },
  {
    image: '/SBA-Cleaning-Team.jpg',
    title: 'Cleaning Team',
    name: ''
  },
  {
    image: 'SBA-Front-Office-Team.jpg',
    title: 'Front Office Team',
    name: ''
  },
  {
    image: '/SBA-Waitress-Team.jpg',
    title: 'Waitress Team',
    name: ''
  },
  {
    image: '/SBA-Bar-Team.jpg',
    title: 'Bar Team',
    name: ''
  },
  {
    image: '/SBA-Director-Benny-Suryadi.jpg',
    title: 'Director',
    name: 'Benny Suryadi'
  },
  {
    image: '/SBA-General-Manager-Ricky-Chia.jpg',
    title: 'General Manager',
    name: 'Ricky Chia'
  },
  {
    image: '/SBA-Operational-Manager-Tude.jpg',
    title: 'Operational Manager',
    name: 'Tude'
  },
  {
    image: '/SBA-Kitchen-Team.jpg',
    title: 'Kitchen Team',
    name: ''
  }
])
</script>

<style></style>
